import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, vModelSelect as _vModelSelect, withModifiers as _withModifiers, withKeys as _withKeys, vModelText as _vModelText, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0968c20"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "error",
  role: "alert"
}
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "documents-table" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_5 = { class: "document-group" }
const _hoisted_6 = {
  colspan: "4",
  scope: "rowgroup"
}
const _hoisted_7 = ["aria-expanded", "onClick"]
const _hoisted_8 = {
  key: 0,
  class: "required"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "muted" }
const _hoisted_12 = { class: "file-names" }
const _hoisted_13 = ["title", "onClick"]
const _hoisted_14 = ["title"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["aria-label"]
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "actions" }
const _hoisted_19 = {
  key: 0,
  class: "document-preview-row"
}
const _hoisted_20 = { colspan: "4" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { colspan: "4" }
const _hoisted_23 = ["aria-label"]
const _hoisted_24 = { class: "documents-table documents-table--unclassified" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_26 = { class: "document-group" }
const _hoisted_27 = {
  colspan: "2",
  scope: "rowgroup"
}
const _hoisted_28 = ["title", "onClick"]
const _hoisted_29 = ["title"]
const _hoisted_30 = { class: "actions" }
const _hoisted_31 = {
  key: 0,
  class: "document-preview-row"
}
const _hoisted_32 = { colspan: "2" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  colspan: "2",
  class: "muted"
}
const _hoisted_35 = ["onSubmit"]
const _hoisted_36 = {
  key: 0,
  class: "error",
  role: "alert"
}
const _hoisted_37 = { key: 1 }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { value: "" }
const _hoisted_40 = ["value"]
const _hoisted_41 = { key: 2 }
const _hoisted_42 = { key: 3 }
const _hoisted_43 = ["value", "disabled"]
const _hoisted_44 = ["value"]
const _hoisted_45 = {
  key: 4,
  class: "muted"
}
const _hoisted_46 = {
  key: 5,
  class: "muted"
}
const _hoisted_47 = { key: 6 }
const _hoisted_48 = {
  key: 7,
  class: "source-switch"
}
const _hoisted_49 = ["disabled"]
const _hoisted_50 = ["disabled"]
const _hoisted_51 = ["onDrop"]
const _hoisted_52 = ["aria-label"]
const _hoisted_53 = ["disabled"]
const _hoisted_54 = {
  key: 0,
  class: "selected-file"
}
const _hoisted_55 = ["disabled"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "muted" }, "PDF, JPG, PNG, DOC, DOCX", -1))
const _hoisted_57 = {
  key: 1,
  role: "status"
}
const _hoisted_58 = { class: "search" }
const _hoisted_59 = ["placeholder", "disabled", "onKeydown"]
const _hoisted_60 = { class: "esign-results" }
const _hoisted_61 = ["value", "disabled"]
const _hoisted_62 = {
  key: 0,
  class: "muted"
}
const _hoisted_63 = ["disabled", "max"]
const _hoisted_64 = ["disabled", "min"]
const _hoisted_65 = {
  key: 11,
  class: "replacement"
}
const _hoisted_66 = ["disabled"]
const _hoisted_67 = { class: "footer" }
const _hoisted_68 = { class: "editor" }
const _hoisted_69 = {
  key: 0,
  class: "error",
  role: "alert"
}
const _hoisted_70 = { class: "footer" }

import { Component, computed, ref, watch } from "vue";
import { Button } from "@/components/common";
import ActionMenu from "@/components/common/ActionMenu.vue";
import {
  DownloadIcon,
  EyeIcon,
  RefreshIcon,
  LinkIcon,
  TrashIcon,
} from "@heroicons/vue/outline";
import Modal from "@/components/common/Modal.vue";
import HrDataService from "@/services/hr/HrDataService";
import HrFilePreview from "@/components/hr/HrFilePreview.vue";
import { canPreviewHrDocument } from "@/utils/hrFilePreview";
import { groupHrDocuments } from "@/utils/hrDocumentGroups";
import { getLocale, t } from "@/i18n";
import { HrChecklistItem, HrEmployeeDetail, HrEmployeeDocument, HrEsignDocument } from "@/types/hr/Hr";

type DocumentAction = {
  text: string;
  icon: Component;
  iconColor: string;
  disabled?: boolean;
  title?: string;
  action: () => void;
};

export default /*#__PURE__*/_defineComponent({
  props: {
    employee: null,
    canManage: null
  },
  emits: ["changed"],
  setup(__props: any, { emit }) {

const props = __props as { employee: HrEmployeeDetail; canManage: boolean }

/* eslint-disable @typescript-eslint/no-unused-vars */


const visibleChecklist = computed(() => props.employee.documents.filter(item => item.required || documents(item).length > 0));
const checklistGroups = computed(() => groupHrDocuments(visibleChecklist.value, item => item.name));
const collapsedGroups = ref<Record<string, boolean>>({ Справки: true });
watch(() => props.employee.id, () => { collapsedGroups.value = { Справки: true }; });
const unclassifiedGroups = computed(() => groupHrDocuments(props.employee.unclassifiedDocuments || [], documentName));
const error = ref("");
const previewDocument = ref<HrEmployeeDocument | null>(null);
function openPreview(doc: HrEmployeeDocument) { if (canPreviewHrDocument(doc)) previewDocument.value = doc; }
watch(() => props.employee.id, () => { previewDocument.value = null; });
const modalError = ref("");
const deleteError = ref("");
const busy = ref(false);
const editorOpen = ref(false);
const mode = ref<"UPLOAD" | "CLASSIFY" | "ESIGN">("UPLOAD");
const typeId = ref("");
const selectedDocument = ref<HrEmployeeDocument | null>(null);
const selectedType = computed(() => props.employee.documents.find(item => item.documentTypeId === typeId.value));
const file = ref<File | null>(null);
const fileInput = ref<HTMLInputElement | null>(null);
const dragging = ref(false);
const issueDate = ref("");
const expiryDate = ref("");
const replacementConfirmed = ref(false);
const query = ref("");
const esignId = ref("");
const esignDocuments = ref<HrEsignDocument[]>([]);
const searching = ref(false);
const searchCompleted = ref(false);
const deleting = ref<HrEmployeeDocument | null>(null);
const hasExisting = computed(() => Boolean(selectedType.value && documents(selectedType.value).some(doc => mode.value !== "CLASSIFY" || doc.id !== selectedDocument.value?.id)));
const contentSelected = computed(() => mode.value === "UPLOAD" ? Boolean(file.value) : mode.value === "ESIGN" ? Boolean(esignId.value) : true);
const requiresReplacementConfirmation = computed(() => !selectedType.value?.allowsMultiple && hasExisting.value && contentSelected.value);
const datesChanged = computed(() => Boolean(selectedDocument.value && (issueDate.value !== (selectedDocument.value.issueDate || "") || expiryDate.value !== (selectedDocument.value.expiryDate || ""))));
const datesOnly = computed(() => mode.value !== "CLASSIFY" && !contentSelected.value && Boolean(selectedDocument.value) && Boolean(selectedType.value?.requiresExpiryDate));
const canSave = computed(() => Boolean(selectedType.value &&
  (!requiresReplacementConfirmation.value || replacementConfirmed.value) &&
  (!selectedType.value.requiresExpiryDate || expiryDate.value) &&
  (contentSelected.value || (datesOnly.value && datesChanged.value))));
const editorTitle = computed(() =>
  mode.value === "CLASSIFY"
    ? t("hr.classifyDocument")
    : selectedType.value?.allowsMultiple
    ? t("hr.addFile")
    : selectedDocument.value
    ? t("hr.updateDocument")
    : t("hr.addDocument")
);
function documents(item: HrChecklistItem) { return item.documents || (item.document ? [item.document] : []); }
function documentName(doc: HrEmployeeDocument) {
  return doc.fileName || doc.esignDocumentTitle || t("hr.document");
}
function shortDocumentName(doc: HrEmployeeDocument) {
  const name = documentName(doc);
  if (name.length <= 48) return name;
  const extension = name.match(/\.[a-z0-9]{1,10}$/i)?.[0] || "";
  return name.slice(0, 47 - extension.length) + "…" + extension;
}
function formatSize(size: number) {
  return size < 1048576
    ? Math.ceil(size / 1024) + " " + t("hr.kilobytes")
    : (size / 1048576).toFixed(1) + " " + t("hr.megabytes");
}
function groupLabel(name: string) {
  const keys: Record<string, string> = {
    Справки: "hr.group.certificates",
    Приказы: "hr.group.orders",
    Заявления: "hr.group.applications",
    Образование: "hr.group.education",
    "Остальные документы": "hr.group.other",
  };
  return keys[name] ? t(keys[name]) : name;
}
function expiryLabel(item: HrChecklistItem) {
  const dates = documents(item).map(doc => doc.expiryDate).filter(Boolean) as string[];
  return dates.length
    ? dates
        .map((date) =>
          new Date(date + "T00:00:00").toLocaleDateString(
            getLocale() === "en" ? "en-GB" : "ru-RU"
          )
        )
        .join(", ")
    : documents(item).length
    ? t("hr.notSpecified")
    : "—";
}
function isExpired(item: HrChecklistItem) { return documents(item).some(doc => doc.expiryDate && new Date(doc.expiryDate + "T23:59:59") < new Date()); }
function downloadAction(doc: HrEmployeeDocument, text: string): DocumentAction {
  return {
    text,
    icon: DownloadIcon,
    iconColor: "text-green-600",
    disabled: Boolean(doc.externalFile),
    title: doc.externalFile
      ? t("hr.metadataOnly")
      : documentName(doc),
    action: () => download(doc),
  };
}
function deleteAction(doc: HrEmployeeDocument, text: string): DocumentAction {
  return {
    text,
    icon: TrashIcon,
    iconColor: "text-red-500",
    title: documentName(doc),
    action: () => askDelete(doc),
  };
}
function previewActions(doc: HrEmployeeDocument, text: string): DocumentAction[] {
  return canPreviewHrDocument(doc) ? [{ text, title: documentName(doc), icon: EyeIcon, iconColor: "text-blue-600", action: () => openPreview(doc) }] : [];
}
function documentActions(item: HrChecklistItem): DocumentAction[] {
  const docs = documents(item);
  const label = (text: string, doc: HrEmployeeDocument) =>
    docs.length > 1 ? `${text}: ${shortDocumentName(doc)}` : text;
  const actions = docs.flatMap(doc => [...previewActions(doc, label(t("hr.show"), doc)), downloadAction(doc, label(t("hr.download"), doc))]);
  if (props.canManage) {
    actions.push({
      text: item.allowsMultiple ? t("hr.addFile") : t("hr.update"),
      icon: RefreshIcon,
      iconColor: "",
      action: () => openEditor("UPLOAD", item),
    });
    if (item.allowsEsignLink)
      actions.push({
        text: t("hr.linkEsign"),
        icon: LinkIcon,
        iconColor: "",
        action: () => openEditor("ESIGN", item),
      });
    actions.push(
      ...docs.map((doc) => deleteAction(doc, label(t("common.delete"), doc)))
    );
  }
  return actions;
}
function unclassifiedActions(doc: HrEmployeeDocument): DocumentAction[] {
  const actions = [...previewActions(doc, t("hr.show")), downloadAction(doc, t("hr.download"))];
  if (props.canManage) {
    actions.push(
      {
        text: t("hr.classify"),
        icon: LinkIcon,
        iconColor: "",
        action: () => openEditor("CLASSIFY", undefined, doc),
      },
      deleteAction(doc, t("common.delete"))
    );
  }
  return actions;
}
function openEditor(
  nextMode: "UPLOAD" | "CLASSIFY" | "ESIGN",
  item?: HrChecklistItem,
  doc?: HrEmployeeDocument
) {
  error.value = "";
  modalError.value = "";
  mode.value = nextMode;
  typeId.value = item?.documentTypeId || ""; selectedDocument.value = doc || (item && !item.allowsMultiple ? documents(item)[0] : null) || null;
  file.value = null; if (fileInput.value) fileInput.value.value = "";
  issueDate.value = selectedDocument.value?.issueDate || ""; expiryDate.value = selectedDocument.value?.expiryDate || ""; replacementConfirmed.value = false;
  query.value = ""; esignId.value = ""; esignDocuments.value = []; searchCompleted.value = false;
  editorOpen.value = true;
}
function chooseCurrentDocument(event: Event) {
  selectedDocument.value = selectedType.value ? documents(selectedType.value).find(doc => doc.id === (event.target as HTMLSelectElement).value) || null : null;
  issueDate.value = selectedDocument.value?.issueDate || "";
  expiryDate.value = selectedDocument.value?.expiryDate || "";
  replacementConfirmed.value = false;
}
function clearFile() {
  file.value = null;
  if (fileInput.value) fileInput.value.value = "";
  replacementConfirmed.value = false;
}
function closeEditor() { if (!busy.value && !searching.value) editorOpen.value = false; }
function selectFile(candidate?: File) {
  if (busy.value || !candidate) return;
  if (!/\.(pdf|jpe?g|png|docx?)$/i.test(candidate.name)) {
    modalError.value = t("hr.invalidFileFormat");
    file.value = null;
    return;
  }
  file.value = candidate; modalError.value = "";
}
function pickFile(event: Event) { selectFile((event.target as HTMLInputElement).files?.[0]); }
function drop(event: DragEvent) {
  dragging.value = false;
  if (event.dataTransfer?.files.length !== 1) {
    modalError.value = t("hr.chooseSingleFile");
    return;
  }
  selectFile(event.dataTransfer.files[0]);
}
async function search() {
  if (searching.value || busy.value) return;
  searching.value = true; modalError.value = ""; searchCompleted.value = false;
  try { esignDocuments.value = (await HrDataService.searchEsignDocuments(query.value)).data.data.items; }
  catch (e) { modalError.value = message(e, t("hr.documentSearchError")); }
  finally { searching.value = false; searchCompleted.value = true; }
}
async function save() {
  if (busy.value || !canSave.value || !selectedType.value) return;
  busy.value = true; modalError.value = "";
  const payload = { documentTypeId: typeId.value, issueDate: selectedType.value.requiresExpiryDate ? issueDate.value || null : null, expiryDate: selectedType.value.requiresExpiryDate ? expiryDate.value || null : null };
  try {
    if (datesOnly.value && selectedDocument.value) {
      await HrDataService.updateEmployeeDocumentDates(props.employee.id, selectedDocument.value.id, { issueDate: payload.issueDate, expiryDate: payload.expiryDate });
    } else if (mode.value === "CLASSIFY" && selectedDocument.value) {
      await HrDataService.classifyEmployeeDocument(props.employee.id, selectedDocument.value.id, { ...payload, replaceExisting: replacementConfirmed.value });
    } else if (mode.value === "ESIGN") {
      await HrDataService.linkEmployeeDocument(props.employee.id, { ...payload, esignDocumentId: esignId.value });
    } else if (file.value) {
      const form = new FormData();
      form.append("file", file.value); form.append("documentTypeId", typeId.value);
      if (payload.issueDate) form.append("issueDate", payload.issueDate);
      if (payload.expiryDate) form.append("expiryDate", payload.expiryDate);
      await HrDataService.uploadEmployeeDocument(props.employee.id, form);
    }
    editorOpen.value = false; emit("changed");
  } catch (e) { modalError.value = message(e, t("hr.documentSaveError")); }
  finally { busy.value = false; }
}
function askDelete(doc: HrEmployeeDocument) {
  deleting.value = doc;
  deleteError.value = "";
}
function closeDelete() { if (!busy.value) deleting.value = null; }
async function remove() {
  if (!deleting.value || busy.value) return;
  busy.value = true; deleteError.value = "";
  try { await HrDataService.archiveEmployeeDocument(props.employee.id, deleting.value.id); deleting.value = null; emit("changed"); }
  catch (e) { deleteError.value = message(e, t("hr.documentDeleteError")); }
  finally { busy.value = false; }
}
async function download(doc: HrEmployeeDocument) {
  if (doc.externalFile) return;
  error.value = "";
  try {
    const response = doc.source === "ESIGN_DOCUMENT" ? await HrDataService.downloadEsignArchive(props.employee.id, doc.id) : await HrDataService.downloadEmployeeDocument(props.employee.id, doc.id);
    const url = URL.createObjectURL(response.data); const anchor = document.createElement("a");
    anchor.href = url; anchor.download = documentName(doc) + (doc.source === "ESIGN_DOCUMENT" ? ".zip" : ""); anchor.click();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  } catch (e) {
    error.value = message(e, t("hr.downloadError"));
  }
}
function message(e: unknown, fallback: string) { return (e as { response?: { data?: { message?: string } } }).response?.data?.message || fallback; }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", null, [
      _createElementVNode("h2", null, _toDisplayString(_unref(t)("hr.personalDocuments")), 1),
      (error.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(error.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "table-scroll",
        style: {"--table-min-width":"680px"},
        tabindex: "0",
        role: "region",
        "aria-label": _ctx.$t('common.scrollableTable')
      }, [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_unref(t)("common.type")), 1),
              _createElementVNode("th", null, _toDisplayString(_unref(t)("hr.documentValidity")), 1),
              _createElementVNode("th", null, _toDisplayString(_unref(t)("hr.documentPresence")), 1),
              _hoisted_4
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(checklistGroups), (group) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: group.name
              }, [
                _createElementVNode("tr", _hoisted_5, [
                  _createElementVNode("th", _hoisted_6, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "group-toggle",
                      "aria-expanded": !collapsedGroups.value[group.name],
                      onClick: ($event: any) => (collapsedGroups.value[group.name] = !collapsedGroups.value[group.name])
                    }, [
                      _createElementVNode("span", null, _toDisplayString(collapsedGroups.value[group.name] ? "▸" : "▾") + " " + _toDisplayString(groupLabel(group.name)), 1),
                      _createElementVNode("small", null, _toDisplayString(group.items.filter(item => documents(item).length).length) + " / " + _toDisplayString(group.items.length), 1)
                    ], 8, _hoisted_7)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: item.documentTypeId
                  }, [
                    _withDirectives(_createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(item.name) + " ", 1),
                        (item.required)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, "*"))
                          : _createCommentVNode("", true),
                        (documents(item).length === 1 && _unref(canPreviewHrDocument)(documents(item)[0]))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "preview-link",
                              onClick: ($event: any) => (openPreview(documents(item)[0]))
                            }, _toDisplayString(_unref(t)("hr.showDocument")), 9, _hoisted_9))
                          : _createCommentVNode("", true),
                        (documents(item).length > 1)
                          ? (_openBlock(), _createElementBlock("details", _hoisted_10, [
                              _createElementVNode("summary", _hoisted_11, _toDisplayString(_unref(t)("hr.fileCount")) + " " + _toDisplayString(documents(item).length), 1),
                              _createElementVNode("ul", _hoisted_12, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documents(item), (doc) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: doc.id
                                  }, [
                                    (_unref(canPreviewHrDocument)(doc))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "preview-link file-name",
                                          title: documentName(doc),
                                          onClick: ($event: any) => (openPreview(doc))
                                        }, _toDisplayString(documentName(doc)), 9, _hoisted_13))
                                      : (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          class: "file-name",
                                          title: documentName(doc)
                                        }, _toDisplayString(documentName(doc)), 9, _hoisted_14))
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, [
                        (item.requiresExpiryDate)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass({ expired: isExpired(item) })
                            }, _toDisplayString(expiryLabel(item)), 3))
                          : (_openBlock(), _createElementBlock("span", _hoisted_15, "—"))
                      ]),
                      _createElementVNode("td", null, [
                        (documents(item).length)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "present",
                              "aria-label": _unref(t)('hr.documentPresent')
                            }, "✓", 8, _hoisted_16))
                          : (__props.canManage)
                            ? (_openBlock(), _createBlock(_unref(Button), {
                                key: 1,
                                type: "button",
                                onClick: ($event: any) => (openEditor('UPLOAD', item))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)("hr.add")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_17, "—"))
                      ]),
                      _createElementVNode("td", _hoisted_18, [
                        (documents(item).length)
                          ? (_openBlock(), _createBlock(ActionMenu, {
                              key: 0,
                              "truncate-labels": true,
                              actions: documentActions(item)
                            }, null, 8, ["actions"]))
                          : _createCommentVNode("", true)
                      ])
                    ], 512), [
                      [_vShow, !collapsedGroups.value[group.name]]
                    ]),
                    (previewDocument.value && documents(item).some(doc => doc.id === previewDocument.value.id))
                      ? _withDirectives((_openBlock(), _createElementBlock("tr", _hoisted_19, [
                          _createElementVNode("td", _hoisted_20, [
                            _createVNode(HrFilePreview, {
                              key: previewDocument.value.id,
                              "employee-id": __props.employee.id,
                              document: previewDocument.value,
                              onClose: _cache[0] || (_cache[0] = ($event: any) => (previewDocument.value = null)),
                              onDownload: _cache[1] || (_cache[1] = ($event: any) => (previewDocument.value && download(previewDocument.value)))
                            }, null, 8, ["employee-id", "document"])
                          ])
                        ], 512)), [
                          [_vShow, !collapsedGroups.value[group.name]]
                        ])
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ], 64))
            }), 128)),
            (!_unref(visibleChecklist).length)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                  _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(t)("hr.noDocumentTypes")), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 8, _hoisted_2)
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("h2", null, _toDisplayString(_unref(t)("hr.unclassifiedFiles")) + " (" + _toDisplayString(__props.employee.unclassifiedDocuments?.length || 0) + ") ", 1),
      _createElementVNode("div", {
        class: "table-scroll",
        style: {"--table-min-width":"480px"},
        tabindex: "0",
        role: "region",
        "aria-label": _ctx.$t('common.scrollableTable')
      }, [
        _createElementVNode("table", _hoisted_24, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_unref(t)("hr.fileName")), 1),
              _hoisted_25
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(unclassifiedGroups), (group) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: group.name
              }, [
                _createElementVNode("tr", _hoisted_26, [
                  _createElementVNode("th", _hoisted_27, _toDisplayString(groupLabel(group.name)), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (doc) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: doc.id
                  }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        (_unref(canPreviewHrDocument)(doc))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "preview-link file-name",
                              title: documentName(doc),
                              onClick: ($event: any) => (openPreview(doc))
                            }, _toDisplayString(documentName(doc)), 9, _hoisted_28))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "file-name",
                              title: documentName(doc)
                            }, _toDisplayString(documentName(doc)), 9, _hoisted_29))
                      ]),
                      _createElementVNode("td", _hoisted_30, [
                        _createVNode(ActionMenu, {
                          "truncate-labels": true,
                          actions: unclassifiedActions(doc)
                        }, null, 8, ["actions"])
                      ])
                    ]),
                    (previewDocument.value?.id === doc.id)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                          _createElementVNode("td", _hoisted_32, [
                            _createVNode(HrFilePreview, {
                              key: doc.id,
                              "employee-id": __props.employee.id,
                              document: doc,
                              onClose: _cache[2] || (_cache[2] = ($event: any) => (previewDocument.value = null)),
                              onDownload: ($event: any) => (download(doc))
                            }, null, 8, ["employee-id", "document", "onDownload"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ], 64))
            }), 128)),
            (!__props.employee.unclassifiedDocuments?.length)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [
                  _createElementVNode("td", _hoisted_34, _toDisplayString(_unref(t)("hr.noUnclassifiedFiles")), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 8, _hoisted_23)
    ]),
    _createVNode(Modal, {
      show: editorOpen.value,
      title: _unref(editorTitle),
      onClose: closeEditor
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          class: "editor",
          onSubmit: _withModifiers(save, ["prevent"])
        }, [
          (modalError.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(modalError.value), 1))
            : _createCommentVNode("", true),
          (mode.value === 'CLASSIFY')
            ? (_openBlock(), _createElementBlock("label", _hoisted_37, [
                _createTextVNode(_toDisplayString(_unref(t)("hr.documentTypeName")) + " ", 1),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((typeId).value = $event)),
                  class: "input-form",
                  required: "",
                  disabled: busy.value,
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (replacementConfirmed.value = false))
                }, [
                  _createElementVNode("option", _hoisted_39, _toDisplayString(_unref(t)("hr.chooseDocumentType")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.employee.documents, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item.documentTypeId,
                      value: item.documentTypeId
                    }, _toDisplayString(item.name), 9, _hoisted_40))
                  }), 128))
                ], 40, _hoisted_38), [
                  [_vModelSelect, typeId.value]
                ])
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString(_unref(selectedType)?.name), 1)),
          (
          mode.value !== 'CLASSIFY' &&
          _unref(selectedType) &&
          documents(_unref(selectedType)).length > 1
        )
            ? (_openBlock(), _createElementBlock("label", _hoisted_42, [
                _createTextVNode(_toDisplayString(_unref(t)("hr.currentDocument")) + " ", 1),
                _createElementVNode("select", {
                  class: "input-form",
                  value: selectedDocument.value?.id,
                  disabled: busy.value,
                  onChange: chooseCurrentDocument
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documents(_unref(selectedType)), (doc) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: doc.id,
                      value: doc.id
                    }, _toDisplayString(documentName(doc)), 9, _hoisted_44))
                  }), 128))
                ], 40, _hoisted_43)
              ]))
            : _createCommentVNode("", true),
          (mode.value !== 'CLASSIFY' && selectedDocument.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(_unref(t)("hr.currentFile")) + " " + _toDisplayString(documentName(selectedDocument.value)), 1))
            : _createCommentVNode("", true),
          (
          mode.value !== 'CLASSIFY' &&
          selectedDocument.value &&
          _unref(selectedType)?.requiresExpiryDate
        )
            ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(_unref(t)("hr.changeDatesOnlyHint")), 1))
            : _createCommentVNode("", true),
          (mode.value === 'CLASSIFY')
            ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(selectedDocument.value ? documentName(selectedDocument.value) : ''), 1))
            : _createCommentVNode("", true),
          (mode.value !== 'CLASSIFY' && _unref(selectedType)?.allowsEsignLink)
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                _createElementVNode("button", {
                  type: "button",
                  disabled: busy.value,
                  class: _normalizeClass({ active: mode.value === 'UPLOAD' }),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (mode.value = 'UPLOAD'))
                }, _toDisplayString(_unref(t)("hr.uploadFile")), 11, _hoisted_49),
                _createElementVNode("button", {
                  type: "button",
                  disabled: busy.value,
                  class: _normalizeClass({ active: mode.value === 'ESIGN' }),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (mode.value = 'ESIGN'))
                }, _toDisplayString(_unref(t)("hr.fromEsign")), 11, _hoisted_50)
              ]))
            : _createCommentVNode("", true),
          (mode.value === 'UPLOAD')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["drop-zone", { dragging: dragging.value }]),
                  onDragover: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (dragging.value = true), ["prevent"])),
                  onDragleave: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (dragging.value = false), ["prevent"])),
                  onDrop: _withModifiers(drop, ["prevent"])
                }, [
                  _createElementVNode("label", {
                    class: "file-picker",
                    tabindex: "0",
                    role: "button",
                    "aria-label": _unref(t)('hr.chooseFile'),
                    onKeydown: [
                      _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (fileInput.value?.click()), ["prevent"]), ["enter"])),
                      _cache[8] || (_cache[8] = _withKeys(_withModifiers(($event: any) => (fileInput.value?.click()), ["prevent"]), ["space"]))
                    ]
                  }, [
                    _createElementVNode("input", {
                      ref: (_value, _refs) => {
                        _refs['fileInput'] = _value
                        fileInput.value = _value
                      },
                      type: "file",
                      disabled: busy.value,
                      accept: ".pdf,.jpg,.jpeg,.png,.doc,.docx",
                      onChange: pickFile
                    }, null, 40, _hoisted_53),
                    _createElementVNode("strong", null, _toDisplayString(file.value ? file.value.name : _unref(t)("hr.dropFile")), 1),
                    _createElementVNode("span", null, _toDisplayString(file.value ? formatSize(file.value.size) : _unref(t)("hr.clickChooseFile")), 1)
                  ], 40, _hoisted_52)
                ], 42, _hoisted_51),
                (file.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                      _createElementVNode("span", null, _toDisplayString(file.value.name), 1),
                      _createElementVNode("button", {
                        type: "button",
                        disabled: busy.value,
                        onClick: clearFile
                      }, _toDisplayString(_unref(t)("hr.clearFile")), 9, _hoisted_55)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_56,
                (busy.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_57, _toDisplayString(_unref(t)("hr.savingFile")), 1))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (mode.value === 'ESIGN')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                _createElementVNode("div", _hoisted_58, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((query).value = $event)),
                    class: "input-form",
                    placeholder: _unref(t)('hr.searchDocuments'),
                    disabled: busy.value,
                    onKeydown: _withKeys(_withModifiers(search, ["prevent"]), ["enter"])
                  }, null, 40, _hoisted_59), [
                    [
                      _vModelText,
                      query.value,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createVNode(_unref(Button), {
                    type: "button",
                    disabled: busy.value || searching.value,
                    onClick: search
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("hr.find")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(esignDocuments.value, (doc) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: doc.id
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((esignId).value = $event)),
                        type: "radio",
                        value: doc.id,
                        disabled: busy.value
                      }, null, 8, _hoisted_61), [
                        [_vModelRadio, esignId.value]
                      ]),
                      _createTextVNode(" " + _toDisplayString(doc.title || _unref(t)("hr.untitledDocument")) + " · " + _toDisplayString(doc.number || _unref(t)("hr.unnumberedDocument")), 1)
                    ]))
                  }), 128)),
                  (searchCompleted.value && !esignDocuments.value.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_62, _toDisplayString(_unref(t)("hr.noDocumentsFound")), 1))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_unref(selectedType)?.requiresExpiryDate)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                _createElementVNode("label", null, [
                  _createTextVNode(_toDisplayString(_unref(t)("hr.issueDate")) + " ", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((issueDate).value = $event)),
                    class: "input-form",
                    type: "date",
                    disabled: busy.value,
                    max: expiryDate.value || undefined
                  }, null, 8, _hoisted_63), [
                    [_vModelText, issueDate.value]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createTextVNode(_toDisplayString(_unref(t)("hr.expiryDate")) + " * ", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((expiryDate).value = $event)),
                    class: "input-form",
                    type: "date",
                    required: "",
                    disabled: busy.value,
                    min: issueDate.value || undefined
                  }, null, 8, _hoisted_64), [
                    [_vModelText, expiryDate.value]
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_unref(requiresReplacementConfirmation))
            ? (_openBlock(), _createElementBlock("label", _hoisted_65, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((replacementConfirmed).value = $event)),
                  type: "checkbox",
                  required: "",
                  disabled: busy.value
                }, null, 8, _hoisted_66), [
                  [_vModelCheckbox, replacementConfirmed.value]
                ]),
                _createTextVNode(" " + _toDisplayString(_unref(t)("hr.replacementHint")), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_67, [
            _createVNode(_unref(Button), {
              type: "button",
              variant: "default",
              disabled: busy.value,
              onClick: closeEditor
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("common.cancel")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_unref(Button), {
              type: "submit",
              disabled: busy.value || !_unref(canSave)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(busy.value ? _unref(t)("hr.saving") : _unref(t)("common.save")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 40, _hoisted_35)
      ]),
      _: 1
    }, 8, ["show", "title"]),
    _createVNode(Modal, {
      show: Boolean(deleting.value),
      title: _unref(t)('hr.deleteDocumentTitle'),
      onClose: closeDelete
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("p", null, _toDisplayString(deleting.value ? documentName(deleting.value) : ''), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(t)("hr.deleteDocumentHint")), 1),
          (deleteError.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_69, _toDisplayString(deleteError.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_70, [
            _createVNode(_unref(Button), {
              type: "button",
              variant: "default",
              disabled: busy.value,
              onClick: closeDelete
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("common.cancel")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_unref(Button), {
              type: "button",
              disabled: busy.value,
              onClick: remove
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(busy.value ? _unref(t)("hr.deleting") : _unref(t)("hr.confirmDeleteDocument")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "title"])
  ], 64))
}
}

})